export const DealerRole = {
  FRANCHISED_DEALER: 'FRANCHISED_DEALER',
  INDEPENDENT_DEALER: 'INDEPENDENT_DEALER',
};

export const DealerRoleName = {
  FRANCHISED_DEALER: 'New / Used Car Franchised Dealer',
  INDEPENDENT_DEALER: 'Independent Dealer',
};
